/* eslint-disable prettier/prettier */
/* prettier-ignore-file */
/* eslint-disable */
import { FC } from 'react';
import styles from '../../styles/components/controlVariations/LogoutConfirmModal.module.css';
import logout from '../../assets/images/icon/logout.png';

interface LogoutConfirmModalProps {
	open: boolean;
	onConfirm: () => void;
	onCancel: () => void;
}

const LogoutConfirmModal: FC<LogoutConfirmModalProps> = ({
	open,
	onConfirm,
	onCancel,
}) => {
	if (!open) return null;

	return (
		<div className={styles.overlay}>
			<div className={styles.modal}>
				<div className={styles.iconWrapper}>
					<span className={styles.icon}>
						<img src={logout} alt="" />
					</span>
				</div>

				<h2 className={styles.title}>Are you sure?</h2>

				<div className={styles.actions}>
					<button className={styles.logoutButton} onClick={onConfirm}>
						Logout
					</button>

					<button className={styles.cancelButton} onClick={onCancel}>
						Cancel
					</button>
				</div>
			</div>
		</div>
	);
};

export default LogoutConfirmModal;
